import { Flex, Space, Text } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { AgerasSquareLogo, Arrows, BelastingdienstIcon } from '../../../../../../../../assets/images'
import { IntegrationForm } from '../IntegrationForm'

interface IntegrationFormProps {
  onNext: () => void
  onCancel: () => void
}

export const IntegrationFormView = ({ onNext, onCancel }: IntegrationFormProps) => {
  const { t } = useTranslation()
  return (
    <Flex flexDirection="column" alignItems="center">
      <Flex alignItems="center">
        <AgerasSquareLogo />
        <Arrows />
        <BelastingdienstIcon />
      </Flex>
      <Space size="s32" />
      <Text variant="h1">{t('vat_declarations.integration_form.form.title')}</Text>
      <Space size="s24" />
      <IntegrationForm onNext={onNext} onCancel={onCancel} />
    </Flex>
  )
}
